module.exports = "<header class=Form__header>{{{ title }}}</header>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/forms/_sub/title.vue
// module id = 424
// module chunks = 0